// ─── Loyalty Engine API base URL ─────────────────────────────
export const LOYALTY_API_BASE =
    process.env.REACT_APP_LOYALTY_API_BASE_URL || "https://localhost:8001";

// ─── Basic Auth header for the Loyalty Engine API ─────────────
const _loyaltyUser = process.env.REACT_APP_LOYALTY_API_USERNAME || "";
const _loyaltyPass = process.env.REACT_APP_LOYALTY_API_PASSWORD || "";
export const LOYALTY_AUTH_HEADER =
    _loyaltyUser || _loyaltyPass
        ? { Authorization: `Basic ${btoa(`${_loyaltyUser}:${_loyaltyPass}`)}` }
        : {};


// ─── Per-section colour palette ──────────────────────────────
export const SECTION_COLORS = {
    tiers: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },
    rewards: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },

    rules: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },
    transactionTypes: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },
    search: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },
    internalJobs: { main: "#3cb0d6", light: "#ecf9fd", gradient: "linear-gradient(135deg, #3cb0d6 0%, #2a9db4 100%)" },
};

// ─── Table pagination ────────────────────────────────────────
export const ROWS_PER_PAGE = 10;

// ─── Reward type display metadata ───────────────────────────
export const REWARD_TYPE_STYLES = {
    POINTS: { label: "Points", bgcolor: "#EDE9FE", color: "#7C3AED" },
    DISCOUNT: { label: "Remise", bgcolor: "#FEF3C7", color: "#D97706" },
    CASHBACK: { label: "Cashback", bgcolor: "#DBEAFE", color: "#2563EB" },
    VOUCHER: { label: "Bon d'achat", bgcolor: "#FCE7F3", color: "#DB2777" },
};
export const REWARD_TYPES = Object.keys(REWARD_TYPE_STYLES).filter(t => t !== "POINTS");
